export var ValueSortOrder;
(function (ValueSortOrder) {
    ValueSortOrder["Index"] = "index";
    ValueSortOrder["Value"] = "value";
    ValueSortOrder["Name"] = "name";
    ValueSortOrder["Description"] = "description";
})(ValueSortOrder || (ValueSortOrder = {}));
export var ValueSortDirection;
(function (ValueSortDirection) {
    ValueSortDirection["Ascending"] = "asc";
    ValueSortDirection["Descending"] = "desc";
})(ValueSortDirection || (ValueSortDirection = {}));
//# sourceMappingURL=ValueSorting.js.map